import http from './http'

const fornecedorService = {
  getAll: page => http.get(`/fornecedores?page=${page}`).then(result => result.data),
  getAllZero: () => http.get(`/fornecedoresall`).then(result => result.data),
  getFor: () => http.get(`/fornecedoresgetfor`).then(result => result.data),
  getTudo: () => http.get(`/fornecedoresgettudo`).then(result => result.data),
  getById: id => http.get(`/fornecedores/${id}`).then(result => result.data.data),
  getByNome: (str, page) => http.get(`/fornecedoresgetnome/${str}?page=${page}`).then(result => result.data),
  getByFornecedor: () => http.get(`/fornecedoresfor`).then(result => result.data.data),
  delete: id => http.delete(`/fornecedoresdelete/${id}`).then(result => result.data.data),
  savePost: data => http({
    method: 'post',
    url: `/fornecedores`,
    data
  }).then(result => result.data.data),
  saveRegistro: data => http({
    method: 'post',
    url: `/fornecedoresregistro`,
    data
  }).then(result => result.data.data),
  savePut: data => http({
    method: 'put',
    url: `/fornecedores/${data.id}`,
    data
  }).then(result => result.data.data),
  savePutfor: data => http({
    method: 'put',
    url: `/fornecedoresputfor/${data.id}`,
    data
  }).then(result => result.data.data)
}
export default fornecedorService
